import React from 'react';

class SectionIntro extends React.Component {
  render() {
    const { eyebrow, title, description } = this.props;
    return (
      <div className="mb-6">
        {eyebrow ? (
          <p className="text-xs sm:text-sm font-semibold tracking-wide uppercase text-[#5B3FE0]">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="mt-2 text-2xl sm:text-3xl font-bold text-[#1F2937]">
          {title}
        </h1>
        {description ? (
          <p className="mt-2 text-sm sm:text-base text-[#6B7280] leading-relaxed">
            {description}
          </p>
        ) : null}
      </div>
    );
  }
}

export default SectionIntro;
